import React from 'react';
import { Box, } from '@waglabs/box-next';
export const Card = (props) => (React.createElement(Box, Object.assign({ bg: "white", border: "1px solid", borderColor: "#D1D1D1", borderRadius: "16px", boxShadow: "0 2px 12px 0 rgba(0,0,0,0.2)" }, props)));
